import React from "react";
import { useBanner } from "../../context/BannerContext";
import Banner from "./Banner";

/** Renders the provider's banner queue. Mount once, inside BannerProvider. */
const BannerHost: React.FC = () => {
  const { banners, removeBanner } = useBanner();

  return (
    <>
      {banners.map((banner, index) => (
        <Banner
          key={banner.id}
          message={banner.message}
          type={banner.type}
          onClose={() => removeBanner(banner.id)}
          // Newest sits at the top of the stack, so offset by distance from the end.
          style={{ bottom: `${(banners.length - 1 - index) * 60}px` }}
        />
      ))}
    </>
  );
};

export default BannerHost;
